import { bindServices } from '@/services/api';
import { getFiltersGlobalFilters, toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { merge } from 'lodash';

const api = bindServices('sequenceTracing');
const { ManageSequenceTraces } = CoreQueries;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'sequenceTraces',

  state: {
    list: [],
    orderBy: '',
    pagination: { ...meta },
    searchTable: '',
    selectedItem: {},
    openCreateOrEdit: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const { sequenceId, filter: drawerFilters, ...restPayload } = payload;
        const baseFilter = `sequenceId eq ${sequenceId}`;
        const drawerFilterStr =
          drawerFilters && Object.keys(drawerFilters).length > 0
            ? getFiltersGlobalFilters({ sequenceTraces: drawerFilters }, 'sequenceTraces')
            : null;
        const filter = drawerFilterStr ? `${baseFilter} and ${drawerFilterStr}` : baseFilter;
        const params = {
          route: 'sequence/traces',
          id: sequenceId,
          params: {
            ...restPayload,
            filter,
            ...ManageSequenceTraces.paged,
          },
        };
        const response = yield call(api.getById, params);
        yield put({
          type: 'queryList',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            searchTable: payload.search,
          },
        });
      } catch (error) {}
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryList(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: merge(state.pagination, toPaginate(payload)),
        searchTable: payload.searchTable ? payload.searchTable : '',
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        orderBy: '',
      };
    },
    setSearchTable(state, { payload }) {
      return {
        ...state,
        searchTable: payload ?? '',
      };
    },
    clearList(state) {
      return {
        ...state,
        list: [],
        pagination: { ...meta },
      };
    },
  },
};

export default Model;
